import { stringCompare } from '@mahawi/eshop-common/src/string-compare';
import { type EOrderStatus } from '@mahawi/eshop-common/src/types';
import { createSlice } from '@reduxjs/toolkit';

import {
  requestFailedMatcher,
  resetLoadingOnRequestFailed,
} from '../async-state';
import { type IAdminOrder, type IOrdersState } from './types';

export const preloadedState: IOrdersState = {
  inProcess: false,
  orders: undefined,
  statusTypeCodes: undefined,
  reviewStatusTypeCodes: undefined,
  updatedAt: undefined,
};

const ordersSlice = createSlice({
  name: 'Orders',
  initialState: preloadedState,
  reducers: {
    ordersLoadByOrderStatusCodes: {
      reducer(state) {
        state.inProcess = true;
        state.orders = undefined;
        state.updatedAt = Date.now();
      },
      prepare(codes: EOrderStatus[], limit: number) {
        return { payload: { orderStatusType: { codes, limit } } };
      },
    },
    ordersLoadByOrderStatusCodesResponse: {
      reducer(state, action: { payload: { orders: IAdminOrder[] } }) {
        state.inProcess = false;
        state.orders = action.payload.orders;
        state.updatedAt = Date.now();
        state.orders.forEach((order) => {
          order.tags.sort((a: string, b: string): number =>
            stringCompare(a, b),
          );
        });
      },
      prepare(orders: IAdminOrder[]) {
        return { payload: { orders } };
      },
    },
    ordersLoadAllOrderStatusTypeCodes() {},
    ordersLoadAllOrderStatusTypeCodesResponse: {
      reducer(state, action: { payload: { statusTypeCodes: string[] } }) {
        state.statusTypeCodes = action.payload.statusTypeCodes;
        state.updatedAt = Date.now();
      },
      prepare(statusTypeCodes: string[]) {
        return { payload: { statusTypeCodes } };
      },
    },
    ordersLoadAllReviewStatusTypeCodes() {},
    ordersLoadAllReviewStatusTypeCodesResponse: {
      reducer(state, action: { payload: { statusTypeCodes: string[] } }) {
        state.reviewStatusTypeCodes = action.payload.statusTypeCodes;
        state.updatedAt = Date.now();
      },
      prepare(statusTypeCodes: string[]) {
        return { payload: { statusTypeCodes } };
      },
    },
    ordersReset(state) {
      state.inProcess = false;
      state.orders = undefined;
      state.updatedAt = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      requestFailedMatcher('Orders'),
      resetLoadingOnRequestFailed,
    );
  },
});

export const {
  ordersLoadByOrderStatusCodes,
  ordersLoadByOrderStatusCodesResponse,
  ordersLoadAllOrderStatusTypeCodes,
  ordersLoadAllOrderStatusTypeCodesResponse,
  ordersLoadAllReviewStatusTypeCodes,
  ordersLoadAllReviewStatusTypeCodesResponse,
  ordersReset,
} = ordersSlice.actions;
export default ordersSlice.reducer;
